import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { addExchangeBet, getAllMatchOddsData, getEventInfo } from "../../store";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import Betslip from "../BetSlip/BetSlip";
import { BsData } from "../../models/BsData";
import MarketOddBtn from "../OddButton/MarketOddBtn";
import {
  EventData,
  MatchOdds,
  Runners,
  MatchOddsRunnerDTO,
} from "../../models/EventData";
import inplay from "../../assets/images/sports/inplay.svg";
import betfair1 from "../../assets/images/betfair1.svg";
import { UserBet } from "../../models/UserBet";
import { marketNameMap } from "../../constants/common-utlits";
import "./MatchOddsTable.scss";

type StoreProps = {
  eventMarkets: MatchOdds[];
  bets: BsData[];
  addExchangeBet: (data) => void;
  eventData?: EventData;
  // marketID: any;
  openBetsData: UserBet[];
};

const MatchOddsTable: React.FC<StoreProps> = (props) => {
  const { bets, addExchangeBet, eventData, eventMarkets, openBetsData } = props;

  const [selectedRow, setSelectedRow] = useState<string>("");
  const disabledStatus = ["suspended", "closed", "suspended-manually"];
  let providerId = sessionStorage.getItem("psProviderId");
  let operatorId = sessionStorage.getItem("psOperatorId");

  // const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const tableFields = [
    {
      key: "teamName",
      Label: "Market",
      className: "market-name-cell-head",
      align: "left",
    },
    {
      key: "Back",
      Label: "Back" + (operatorId === "MPC1" ? " (L)" : ""),
      className: "odds-cell-head",
      align: "right",
    },
    {
      key: "Lay",
      Label: "Lay" + (operatorId === "MPC1" ? " (K)" : ""),
      className: "odds-cell-head",
      align: "left",
    },
  ];

  const getOpenBetsPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;

    const mOpenBets = openBetsData.filter((b) => b.marketName === marketName);
    for (let bet of mOpenBets) {
      const plVal = bet.oddValue * bet.stakeAmount - bet.stakeAmount;
      if (bet.betType === "BACK") {
        if (bet.runnerId === runner.runnerId) {
          returns ? (returns += plVal) : (returns = plVal);
        } else {
          returns
            ? (returns -= bet.stakeAmount)
            : (returns = 0 - bet.stakeAmount);
        }
      } else if (bet.betType === "LAY") {
        if (bet.runnerId !== runner.runnerId) {
          returns ? (returns += bet.stakeAmount) : (returns = bet.stakeAmount);
        } else {
          returns ? (returns -= plVal) : (returns = 0 - plVal);
        }
      }
    }
    const retVal = returns ? returns : null;
    return retVal;
  };

  const getOpenBetsPLInArray = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    return [getOpenBetsPL(marketId, marketName, runner)];
  };

  const getTotalPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketName === marketName && b.stakeAmount && b.stakeAmount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(marketId, marketName, runner);
      for (let bet of mBetslipBets) {
        const plVal = bet.oddValue * bet.stakeAmount - bet.stakeAmount;
        if (bet.betType === "BACK") {
          if (bet.runnerId === runner.runnerId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns
              ? (returns -= bet.stakeAmount)
              : (returns = 0 - bet.stakeAmount);
          }
        } else if (bet.betType === "LAY") {
          if (bet.runnerId !== runner.runnerId) {
            returns
              ? (returns += bet.stakeAmount)
              : (returns = bet.stakeAmount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    return [returns];
  };

  return (
    <>
      <div className="matchodds-table-ctn">
        <div className="matchodds-table-content table-ctn">
          {eventMarkets?.length > 0
            ? eventMarkets.map((market, index) => {
                return (
                  <>
                    <TableContainer key={index} component={Paper}>
                      <Table className="matchodds-table">
                        <colgroup>
                          <col className="runner-col" />
                          <col className="odds-col" />
                          <col className="odds-col" />
                        </colgroup>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={3}>
                              <div className="market-name-cell-head-ctn">
                                <div className="market">
                                  {eventData?.status === "IN_PLAY" ? (
                                    <img src={inplay} alt="inplay" />
                                  ) : null}

                                  {operatorId === "MPC1"
                                    ? marketNameMap[market.marketName]
                                    : market.marketName}
                                </div>
                                <div className="limit">
                                  <div className="limit-values">
                                    Min :
                                    {market?.limits?.minBetValue
                                      ? " " + market?.limits?.minBetValue
                                      : "N/A"}{" "}
                                    <span>{"    "}</span>
                                    Max :
                                    {market?.limits?.maxBetValue
                                      ? market?.limits?.maxBetValue
                                      : "N/A"}
                                  </div>

                                  {providerId === "BetFair" ? (
                                    <img
                                      className="img"
                                      src={betfair1}
                                      height={20}
                                      width={48}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow className="tbody-header">
                            {tableFields.map((tF, index) => (
                              <TableCell
                                key={tF.key + index}
                                align={
                                  tF.align === "left"
                                    ? "left"
                                    : tF.align === "right"
                                    ? "right"
                                    : "center"
                                }
                                className={tF.className}
                              >
                                {tF.key === "lay" || "back" ? (
                                  <div
                                    className={tF.key.toLowerCase() + "-odd"}
                                  >
                                    {tF.Label}
                                  </div>
                                ) : (
                                  tF.Label
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                          {market.runners?.length > 0 ? (
                            <>
                              {market.runners.map((runner) => (
                                <MatchOddsRow
                                  getOpenBetsPL={getOpenBetsPLInArray}
                                  getTotalPL={getTotalPL}
                                  runner={runner}
                                  addExchangeBet={addExchangeBet}
                                  disabledStatus={disabledStatus}
                                  eventData={eventData}
                                  marketName={market.marketName}
                                  marketId={market.marketId}
                                  market={market}
                                  bets={bets}
                                  selectedRow={selectedRow}
                                  setSelectedRow={setSelectedRow}
                                  min={
                                    market?.limits?.minBetValue
                                      ? market?.limits?.minBetValue
                                      : 0
                                  }
                                  max={
                                    market?.limits?.maxBetValue
                                      ? market?.limits?.maxBetValue
                                      : 0
                                  }
                                />
                              ))}
                            </>
                          ) : (
                            <>
                              <TableRow>
                                <TableCell colSpan={3}>
                                  <div className="fm-table-msg-text">
                                    No Match Odds for this event
                                  </div>
                                </TableCell>
                              </TableRow>
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                );
              })
            : null}
        </div>
      </div>
    </>
  );
};

type MatchOddsRowProps = {
  runner: Runners;
  disabledStatus: string[];
  bets: BsData[];
  addExchangeBet: (data) => void;
  eventData: EventData;
  marketName: string;
  selectedRow: string;
  marketId: string;
  setSelectedRow: (data) => void;
  getOpenBetsPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO,
    type: string
  ) => number[];
  getTotalPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => number[];
  min: number;
  max: number;
  market: MatchOdds;
};

const MatchOddsRow: React.FC<MatchOddsRowProps> = (props) => {
  const {
    runner,
    marketId,
    addExchangeBet,
    disabledStatus,
    eventData,
    marketName,
    bets,
    selectedRow,
    setSelectedRow,
    getOpenBetsPL,
    getTotalPL,
    min,
    max,
    market,
  } = props;

  let backPrices = runner.backPrices;
  if (backPrices.length < 3) {
    if (backPrices.length === 2) backPrices.push({ price: 0, size: 0 });
    if (backPrices.length === 1) {
      backPrices.push({ price: 0, size: 0 });
      backPrices.push({ price: 0, size: 0 });
    }
    if (backPrices.length === 0) {
      backPrices.push({ price: 0, size: 0 });
      backPrices.push({ price: 0, size: 0 });
      backPrices.push({ price: 0, size: 0 });
    }
  }
  runner.backPrices = backPrices;
  let layPrices = runner.layPrices;
  if (layPrices.length < 3) {
    if (layPrices.length === 2) layPrices.push({ price: 0, size: 0 });
    if (layPrices.length === 1) {
      layPrices.push({ price: 0, size: 0 });
      layPrices.push({ price: 0, size: 0 });
    }
    if (layPrices.length === 0) {
      layPrices.push({ price: 0, size: 0 });
      layPrices.push({ price: 0, size: 0 });
      layPrices.push({ price: 0, size: 0 });
    }
  }
  runner.layPrices = layPrices;
  // const scrollTopMob = (marketName: string) => {
  //   if (marketName === "Match Odds")
  //     window.scrollTo({
  //       top: 130,
  //       behavior: "smooth",
  //     });
  // };
  return (
    <>
      <TableRow>
        <TableCell className="team-name-cell">
          <div className="team">{runner.runnerName}</div>
          <div className="risk-ctn">
            <div>
              {getOpenBetsPL(
                eventData.marketId,
                marketName,
                runner,
                "array"
              ).map((ret) =>
                ret !== null ? (
                  <span className={ret >= 0 ? "profit" : "loss"}>
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}
            </div>
            <div>
              {getTotalPL(eventData.marketId, marketName, runner).map((ret) =>
                ret !== null ? (
                  <span className={ret >= 0 ? "profit" : "loss"}>
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}
            </div>
          </div>
        </TableCell>

        <TableCell className="odds-cell">
          <div className="odds-block web-view back-odds-block">
            {runner.backPrices.length > 0 ? (
              runner.backPrices.map((odds, idx) => (
                <MarketOddBtn
                  mainValue={odds.price ? odds.price : 0}
                  subValue={odds.size}
                  oddType="back-odd"
                  valueType="matchOdds"
                  showSubValueinKformat={true}
                  oddsSet={[
                    runner.backPrices && runner.backPrices[0]
                      ? runner.backPrices[0].price
                      : 0,
                    runner.backPrices && runner.backPrices[1]
                      ? runner.backPrices[1].price
                      : 0,
                    runner.backPrices && runner.backPrices[2]
                      ? runner.backPrices[2].price
                      : 0,
                  ]}
                  key={idx}
                  disable={
                    eventData.eventId !== "28127348" &&
                    (disabledStatus.includes(eventData.status.toLowerCase()) ||
                      eventData.status !== "IN_PLAY" ||
                      disabledStatus.includes(market.status.toLowerCase()) ||
                      disabledStatus.includes(runner.status.toLowerCase()))
                  }
                  onClick={() => {
                    if (
                      eventData.eventId === "28127348" ||
                      eventData.status === "IN_PLAY"
                    )
                      addExchangeBet({
                        eventId: eventData.eventId,
                        eventName: eventData.eventName,
                        marketId: marketId,
                        marketName: marketName,
                        oddValue: odds.price,
                        betType: "BACK",
                        marketType: "MATCH_ODDS",
                        stakeAmount: 0,
                        runnerId: runner.runnerId,
                        runnerName: runner.runnerName,
                        competitionId: eventData.competitionId,
                        sportId: eventData.sportId,
                        maxLimit: max,
                        minLimit: min,
                      });
                  }}
                />
              ))
            ) : (
              <></>
            )}
          </div>
          <div className="odds-block mob-view">
            <MarketOddBtn
              mainValue={
                runner.backPrices && runner.backPrices[0]
                  ? runner.backPrices[0].price
                  : 0
              }
              subValue={
                runner.backPrices && runner.backPrices[0]
                  ? runner.backPrices[0].size
                  : 0
              }
              oddType="back-odd"
              valueType="matchOdds"
              showSubValueinKformat={true}
              disable={
                eventData.eventId !== "28127348" &&
                (disabledStatus.includes(eventData.status.toLowerCase()) ||
                  eventData.status !== "IN_PLAY" ||
                  disabledStatus.includes(market.status.toLowerCase()) ||
                  disabledStatus.includes(runner.status.toLowerCase()))
              }
              onClick={() => {
                if (
                  eventData.eventId === "28127348" ||
                  eventData.status === "IN_PLAY"
                ) {
                  addExchangeBet({
                    eventId: eventData.eventId,
                    eventName: eventData.eventName,
                    marketId: marketId,
                    marketName: marketName,
                    marketType: "MATCH_ODDS",
                    oddValue:
                      runner.backPrices && runner.backPrices[0]
                        ? runner.backPrices[0].price
                        : 0,
                    betType: "BACK",
                    stakeAmount: 0,
                    runnerId: runner.runnerId,
                    runnerName: runner.runnerName,
                    competitionId: eventData.competitionId,
                    sportId: eventData.sportId,
                    maxLimit: max,
                    minLimit: min,
                  });
                  setSelectedRow(
                    marketId + runner.runnerId + marketName + "MO"
                  );
                  // scrollTopMob(marketName);
                }
              }}
            />
          </div>
        </TableCell>
        <TableCell className="odds-cell">
          <div className="odds-block web-view">
            {runner.layPrices.length > 0 ? (
              runner.layPrices.map((odds, idx) => (
                <MarketOddBtn
                  mainValue={odds.price ? odds.price : 0}
                  subValue={odds.size ? odds.size : 0}
                  oddType="lay-odd"
                  valueType="matchOdds"
                  showSubValueinKformat={true}
                  oddsSet={[
                    runner.layPrices && runner.layPrices[0]
                      ? runner.layPrices[0].price
                      : 0,
                    runner.layPrices && runner.layPrices[1]
                      ? runner.layPrices[1].price
                      : 0,
                    runner.layPrices && runner.layPrices[2]
                      ? runner.layPrices[2].price
                      : 0,
                  ]}
                  key={idx}
                  disable={
                    (eventData.eventId !== "28127348" &&
                      (disabledStatus.includes(
                        eventData.status.toLowerCase()
                      ) ||
                        eventData.status !== "IN_PLAY")) ||
                    disabledStatus.includes(market.status.toLowerCase()) ||
                    disabledStatus.includes(runner.status.toLowerCase())
                  }
                  onClick={() => {
                    if (
                      eventData.eventId === "28127348" ||
                      eventData.status === "IN_PLAY"
                    )
                      addExchangeBet({
                        eventId: eventData.eventId,
                        eventName: eventData.eventName,
                        marketId: marketId,
                        marketName: marketName,
                        marketType: "MATCH_ODDS",
                        oddValue: odds.price,
                        betType: "LAY",
                        stakeAmount: 0,
                        runnerId: runner.runnerId,
                        runnerName: runner.runnerName,
                        competitionId: eventData.competitionId,
                        // eventTypeId: eventData.sportId,
                        operatorId: "",
                        providerId: "",
                        sportId: eventData.sportId,
                        maxLimit: max,
                        minLimit: min,
                      });
                  }}
                />
              ))
            ) : (
              <></>
            )}
          </div>
          <div className="odds-block mob-view">
            <MarketOddBtn
              mainValue={
                runner.layPrices && runner.layPrices[0]
                  ? runner.layPrices[0].price
                  : 0
              }
              subValue={
                runner.layPrices && runner.layPrices[0]
                  ? runner.layPrices[0].size
                  : 0
              }
              oddType="lay-odd"
              valueType="matchOdds"
              showSubValueinKformat={true}
              disable={
                (eventData.eventId !== "28127348" &&
                  (disabledStatus.includes(eventData.status.toLowerCase()) ||
                    eventData.status !== "IN_PLAY")) ||
                disabledStatus.includes(market.status.toLowerCase()) ||
                disabledStatus.includes(runner.status.toLowerCase())
              }
              onClick={() => {
                if (
                  eventData.eventId === "28127348" ||
                  eventData.status === "IN_PLAY"
                )
                  addExchangeBet({
                    eventId: eventData.eventId,
                    eventName: eventData.eventName,
                    marketId: marketId,
                    marketName: marketName,
                    marketType: "MATCH_ODDS",
                    oddValue:
                      runner.layPrices && runner.layPrices[0]
                        ? runner.layPrices[0].price
                        : 0,
                    betType: "LAY",
                    stakeAmount: 0,
                    runnerId: runner.runnerId,
                    runnerName: runner.runnerName,
                    competitionId: eventData.competitionId,
                    sportId: eventData.sportId,
                    maxLimit: max,
                    minLimit: min,
                  });

                setSelectedRow(marketId + runner.runnerId + marketName + "MO");
                // scrollTopMob(marketName);
              }}
            />
          </div>
        </TableCell>
      </TableRow>

      {bets.length > 0 &&
      selectedRow === marketId + runner.runnerId + bets[0].marketName + "MO" ? (
        <TableRow className="mob-view">
          <TableCell colSpan={3}>
            {" "}
            <Betslip page={"market"} />{" "}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const eInfo = state.sportsBook.eventInfo;
  return {
    bets: state.betslip.bets,
    eventData: state.sportsBook.eventInfo,
    eventMarkets: getAllMatchOddsData(state.sportsBook.eventInfo),
    openBetsData: state.betslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchOddsTable);
